import { render, staticRenderFns } from "./internalActionImprove.vue?vue&type=template&id=4c940928"
import script from "./internalActionImprove.vue?vue&type=script&lang=js"
export * from "./internalActionImprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c940928')) {
      api.createRecord('4c940928', component.options)
    } else {
      api.reload('4c940928', component.options)
    }
    module.hot.accept("./internalActionImprove.vue?vue&type=template&id=4c940928", function () {
      api.rerender('4c940928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/internalActionImprove.vue"
export default component.exports